<template>
  <div class="container">
    <head-nav-bar
      title="查看就诊卡"
      :fixed="true"
      @click-left="$router.go(-1)"
    />
    <div class="mt-header-nav">
      <div class="code-wraper">
        <van-tabs v-model="tabActive" ref="tabs">
          <van-tab title="就诊卡">
            <div class="barcode">
              <div style="padding-top: 15px;">
                <barcode
                  :value="form.cardNo"
                  :options="barcode_option"
                  tag="svg"
                ></barcode>
              </div>
            </div>
          </van-tab>
          <van-tab title="电子健康卡">
            <div class="ewm-wraper">
              <div class="ewm">
                <div
                  v-if="form.qrCodeText && form.qrCodeText != '空'"
                  class="qrcode-wraper"
                >
                  <qrcode
                    :value="form.qrCodeText"
                    :options="{ size: 120 }"
                  ></qrcode>
                  <img class="qrcode-image" src="/images/ybk-logo.png" />
                </div>
                <div v-else class="bind-button">
                  <van-button
                    @click.stop="onRegisterHealthCard(item.obj)"
                    size="mini"
                    >绑定电子健康卡</van-button
                  >
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>

      <div class="info-wraper">
        <van-cell-group>
          <van-cell title="患者姓名">
            <div class="cell-value">{{ form.cardholderName }}</div>
          </van-cell>
          <van-cell title="与本人关系">
            <div class="cell-value">{{ form.relationTypeDesc }}</div>
          </van-cell>
          <van-cell title="出生日期">
            <div class="cell-value">{{ form.cardholderBirthDate }}</div>
          </van-cell>
          <van-cell title="性别">
            <div class="cell-value">{{ form.cardholderSexName }}</div>
          </van-cell>
          <van-cell title="手机号码">
            <div class="cell-value">
              {{ form.cardholderContactPhoneProcted }}
            </div>
          </van-cell>
          <van-cell title="卡类型">
            <div class="cell-value">{{ form.cardTypeDesc }}</div>
          </van-cell>
          <van-cell title="就诊卡号">
            <div class="cell-value">{{ form.cardNo }}</div>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="info-wraper" style="margin-bottom: 30px;">
        <van-cell center title="设为默认就诊卡">
          <template #right-icon>
            <van-switch
              v-model="form.isDefault"
              size="24"
              @change="onIsDefaultChange"
            />
          </template>
        </van-cell>
      </div>
      <!-- QrCodeText -->
      <!-- <div v-if="form.qrCodeText" class="qr-code">
        <qrcode
          v-if="form.qrCodeText"
          :value="form.qrCodeText"
          :options="{ size: 120 }"
        ></qrcode>
        <span class="health-no">电子健康卡</span>
      </div> -->
      <div class="info-wraper">
        <van-button block @click.stop="onEdit" class="mb">修改信息</van-button>
        <van-button block plain type="danger" @click="onDel"
          >解除绑定</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  Field,
  Cell,
  CellGroup,
  Button,
  Dialog,
  Toast,
  Tab,
  Tabs,
  Switch,
} from "vant";
import Barcode from "@xkeshi/vue-barcode";
import VueQrcode from "@xkeshi/vue-qrcode";
import { cache } from "@/utils/common";

export default {
  name: "userContactInfo",
  components: {
    Barcode,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [VueQrcode.name]: VueQrcode,
    [Switch.name]: Switch,

    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  data() {
    return {
      title: "添加就诊人",
      // barcodes: "12345789",
      barcode_option: {
        displayValue: true, //是否默认显示条形码数据
        //textPosition  :'top', //条形码数据显示的位置
        background: "#fff", //条形码背景颜色
        valid: function(valid) {
          console.log(valid);
        },
        width: "2px",
        height: "55px",
        fontSize: "22px", //字体大小
      },
      form: {},
      imgurl: "",
      tabActive: "0",
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.form.id = this.$route.query.Id;
      if (this.form.id) {
        this.getInfo();
      }
    },
    getInfo() {
      this.$post("Contact_Info", { Id: this.form.id })
        .then((res) => {
          this.form = res.data;
          this.imgurl = "data:image/jpeg;base64," + this.form.qrCodeText;
        })
        .catch(() => {});
    },
    onEdit() {
      this.$router.push({
        name: "userContactEdit",
        replace: true,
        query: {
          id: this.form.id,
        },
      });
    },
    onDel() {
      Dialog.confirm({
        message: "确认解除绑定该就诊人吗？",
      })
        .then(() => {
          this.$post("Contact_Del", { Id: this.form.id }).then(() => {
            Toast.success("解绑成功！");
            this.$router.push({ name: "userContactList", replace: true });
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    onIsDefaultChange(value) {
      if (value) {
        this.$post("SetIsDefaultCard", { id: this.form.id }).then();
        cache.set("currentContact", this.form, 24 * 60 * 60 * 1000);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #f5f5f5;
  min-height: 100vh;
  margin-bottom: 0;
}
.barcode {
  text-align: center;
  padding: 10px;
  height: 130px;
}
.qr-code {
  text-align: center;
  margin: 5px 0;
  padding-bottom: 10px;
  .health-no {
    display: block;
    font-size: 14px;
    margin-top: -10px;
  }
}
.ewm {
  right: 20px;
  bottom: 30px;
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  margin: 0 auto;
  border: 1px solid #ddd;
}
.ewm-wraper {
  text-align: center;
  padding: 20px 0 0 0;
  height: 130px;
}
.code-wraper {
}
.bind-button {
  font-size: 0;
}
.info-wraper {
  padding: 10px 10px 0 10px;
  border-radius: 5px;
  overflow: hidden;
}
.cell-value {
  color: #333;
}
.mb {
  margin-bottom: 10px;
}
</style>
